<template>
  <div :class="[
      $style.cardContainer,
      $style['topSpacing-' + topSpacing],
      { [$style.blank]: blank }
      ]">
    <slot>Content...</slot>
  </div>
</template>

<script>
export default {
  name: "card-container",
  props: {
    blank: { type: Boolean, default: false },
    topSpacing: {
      type: String,
      required: false,
      default: "none",
      validator: function (value) {
        return ["none", "xs", "s", "m", "l", "xl"].indexOf(value) !== -1;
      }
    }
  }
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.colors";
@import "../../style/abstract/abstract.functions";
@import "../../style/abstract/abstract.spacing";

.cardContainer {
  box-shadow: $box-shadow;
  padding: rem-calc($spacing-l);
  background-color: $color-white;
}

.blank {
  box-shadow: none;
  background-color: transparent;
}

$sizes: (
    "none": 0,
    "xs": $spacing-xs,
    "s": $spacing-s,
    "m": $spacing-m,
    "l": $spacing-l,
    "xl": $spacing-xl
);

@each $size, $spacing in $sizes {
  .topSpacing-#{$size} {
    margin-top: $spacing
  }
}
</style>
